import type { CorrectComponentType } from "@brytdesigns/web-component-core/utils";

import {
	provideCartPathContext,
	useCartPath,
	type CartPath,
} from "../hooks/index.js";

export type Props = {
	itemIndex: string;
};

export const Name = "cart-data-array-item";

export const Component: CorrectComponentType<Props> = (props, { element }) => {
	if (!props.itemIndex)
		return console.warn(`${Name}: No path attribute provided.`);

	const mergedProps = {
		element,
		path: () => props.itemIndex,
	};

	const fullPath = useCartPath(mergedProps as any);
	provideCartPathContext({
		element,
		path: fullPath,
	});
};
